import { useAccount } from '@/contexts/AccountContext'
import { Tabs, TabsList, TabsTrigger, TabsContent } from '@/components/ui/tabs'
import { EventMappingsTab } from '../components/EventMappingsTab'
import { EventRulesTab } from '../components/EventRulesTab'
import { EntityColRulesTab } from '../components/EntityColRulesTab'

export function DerivationConfigPage() {
  const { selectedAccountId } = useAccount()

  const accId =
    selectedAccountId && selectedAccountId !== 'ALL'
      ? parseInt(selectedAccountId, 10)
      : undefined

  return (
    <div className="p-6">
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-gray-900">Derivation Config</h1>
        <p className="text-gray-500 text-sm mt-1">
          Configure how incoming events are mapped to entity and customer updates.
        </p>
      </div>

      <Tabs defaultValue="event-rules">
        <TabsList className="mb-4">
          <TabsTrigger value="event-rules">Event Rules</TabsTrigger>
          <TabsTrigger value="event-mappings">Event Mappings</TabsTrigger>
          <TabsTrigger value="entity-col-rules">Entity Column Templates</TabsTrigger>
        </TabsList>

        <TabsContent value="event-rules">
          <EventRulesTab accId={accId} />
        </TabsContent>

        <TabsContent value="event-mappings">
          <EventMappingsTab accId={accId} />
        </TabsContent>

        <TabsContent value="entity-col-rules">
          <EntityColRulesTab accId={accId} />
        </TabsContent>
      </Tabs>
    </div>
  )
}
